enum FormErrorTypeEnum {
  EmailNotUnique = 'Email not unique',
  Unknown = 'An unknown error has occurred, please try again',
}

export default FormErrorTypeEnum;
